<template>
  <div class="title_label_container d-flex text-align-center" :class="{ 'justify-content-center' : centerAlign, 'is-title': isTitle, 'is-caption': isCaption }" >
    <h6 class="mb-0">{{ text }}</h6>
  </div>
</template>

<script>
  export default
  {
    name : 'sectionTitleAndLabel',
    props:{
      text:{
        type:String
      },
      mode:{
        type:String
      },
      centerAlign:{
        type:Boolean
      }
    },
    computed: {
      isCaption() {
        return this.mode == 'caption';
      },
      isTitle() {
        return this.mode == 'title';
      }
    }
  }
</script>

<style scoped>
  .title_label_container{
    z-index: 1;
    background:white;    
  }
  .title_label_container h6 {
    font-size: 12px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/sectionTitleAndLabel.vue